"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IndicatorText = void 0;
var _encoreFoundation = require("@spotify-internal/encore-foundation");
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var IndicatorText = exports.IndicatorText = _styledComponents["default"].span.withConfig({
  displayName: "IndicatorText",
  componentId: "sc-7u3ecx-0"
})(["color:", ";padding-inline-start:", ";@media (max-width:", "){flex:1;}"], (0, _index.cssColorValue)(_index.semanticColors.textSubdued), (0, _index.cssSpacing)('tighter-4', '4px'), _encoreFoundation.screenXsMax);